import React from 'react'
import List from '../crud/list'
import menuItems from './menuItems'

const columns = [
  { title: 'Title', prop: 'title' },
  { title: 'Facilitator', prop: 'facilitator_id', references: 'admin/users', referenceProp: 'name' },
  { title: 'Start At', prop: 'start_at', format: 'date', sortable: false },
  { title: 'Num Registrants', prop: 'num_registrants', sortable: false },
  { title: 'Created', prop: 'created_at', format: 'fromNow' }
]

const filters = [
  { name: 'Filter by title', prop: 'filters.title_ilike', type: 'text', enabled: true },
  {
    name: 'Filter by facilitator',
    prop: 'filters.facilitator_id',
    type: 'autocomplete',
    references: 'admin/users',
    referenceProp: 'fullname',
    displayProp: 'name',
    enabled: true,
    query: {
      filters: {
        roles_json_contains: 'facilitator'
      }
    }
  }
]

const defaults = {
  order: [{ column: 'created_at', direction: 'desc' }]
}

const Courses = props => (
  <List
    title='Multi-Week Courses'
    apiPath='admin/courses'
    columns={columns}
    filters={filters}
    defaults={defaults}
    buildMenuItems={menuItems}
    locationPathname={props.location.pathname}
    locationSearch={props.location.search}
  />
)

export default Courses
